import { DisplayInputValue } from '../ProviderAutocomplete/AutocompleteInput/AutocompleteInput';

export interface FilterInterface {
  initFilter: FilterEntityInterface;
  nameOfSearch: string;

  updateFilter(entity: FilterEntityInterface): void;
}

export interface UseSelectionInterface {
  checkedEntity: CheckboxEntityType;

  onChangeHandler(value: string): void;
}

export interface UseTextFieldInterface {
  checkedEntity: string;

  onChangeHandler(value: string): void;
  isValid: RegExpMatchArray | null;
}

export interface UseDistanceInterface extends UseSelectionInterface {
  isValid: RegExpMatchArray | null | boolean;
}

export interface TextFieldInputProps extends UseSelectionInterface {
  groupName: string;
  placeHolder?: string;
  isValid?: RegExpMatchArray | null | boolean;
}

export enum GenderEnum {
  GENDER_ALL = 'All',
  GENDER_MALE = 'Male',
  GENDER_FEMALE = 'Female',
}

export enum CountryEnum {
  COUNTRY_ALL = 'All',
  COUNTRY_CANADA = 'Canada',
  COUNTRY_USA = 'USA',
}

export enum SearchTypeEnum {
  SEARCH_TYPE_ALL = 'All',
  SEARCH_TYPE_PRACTITIONERS = 'PRACTITIONERS',
  SEARCH_TYPE_ORGANIZATIONS = 'ORGANIZATIONS',
}

export enum ProvidersEnum {
  PROVIDERS = 'Providers',
  FACILITIES = 'Facilities',
}

export enum DistanceEnum {
  DISTANCE_NONE = '',
  DISTANCE_1 = '1',
  DISTANCE_5 = '5',
  DISTANCE_10 = '10',
  DISTANCE_25 = '25',
  DISTANCE_50 = '50',
}

export interface OptionSelectionInterface {
  labelFormatter?(value: string): string;
}

export interface FilterEntityInterface {
  distance: CheckboxEntityType;
  provinces: CheckboxEntityTypeObj[];
  languages: CheckboxEntityTypeObj[];
  gender: CheckboxEntityType;
  country: CheckboxEntityType;
  catchmentArea: CheckboxEntityTypeObj[];
  specialty: CheckboxEntityTypeObj[];
  city: CheckboxEntityType;
  name: CheckboxEntityType;
  near: CheckboxEntityType;
}

interface GroupsInterface {
  checkedEntity: CheckboxEntityType;
  totalEntities: DisplayInputValue[];
  groupName: string;
}

export interface GroupsMultiSelectInterface extends GroupsInterface {
  onChangeHandler(value: string[]): void;
}

export interface GroupsMultiSelectInterfaceProps {
  checkedEntity: CheckboxEntityTypeObj[];
  totalEntities: DisplayInputValue[];
  groupName: string;
  placeholder: string;
  onChangeHandler(value: { code: string; display: string }[]): void;
}

export interface GroupsSelectInterface extends GroupsInterface {
  onChangeHandler(value: string): void;

  labelFormatter?(value: string): string;
}

export type CheckboxEntityType = string[];
export type CheckboxEntityTypeObj = { code: string; display: string };
